import { createAction, createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type {
  CreateThreadPayload, ThreadsState, AddShowToThreadPayload, CreateShowCallThreadPayload,
} from '@sda/interfaces/reducer/threads.reducer';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Thread } from '@sda/interfaces/thread';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const startCreateShowThread = createAction<CreateThreadPayload>(`${Reducers.THREADS}/startCreateShowThread`);
export const startDuplicateShow = createAction<string>(`${Reducers.THREADS}/startDuplicateShow`);
export const startCreateShowCallThread = createAction<CreateShowCallThreadPayload>(`${Reducers.THREADS}/startCreateShowCallThread`);
export const startAddShowToThread = createAction<AddShowToThreadPayload>(`${Reducers.THREADS}/startAddShowToThread`);
export const startDeleteThread = createAction<string>(`${Reducers.THREADS}/startDeleteThread`);

/**
 * Fetching
 */
export const startFetchFullThread = createAction<string>(`${Reducers.THREADS}/startFetchFullThread`);
export const unsubscribeFullThread = createAction<string>(`${Reducers.THREADS}/unsubscribeFullThread`);

export const threadAdapter = createEntityAdapter<Thread & FetchDataType>();

const initialState: ThreadsState = {
  current: null,
  threadDeletions: [],
};

const threadsSlice = createSlice({
  initialState: threadAdapter.getInitialState<ThreadsState>(initialState),
  name: Reducers.THREADS,
  reducers: {
    ...extractSharedActions(threadAdapter),
    addThreadDeletion: (state, action: PayloadAction<string>) => {
      state.threadDeletions = [
        ...state.threadDeletions,
        action.payload,
      ];
    },
    setCurrentThread: (state, action: PayloadAction<{ threadId: string }>) => {
      state.current = action.payload?.threadId;
    },
  },
});

export const {
  removeOne: removeThread, upsertOne: upsertThread, updateOne: updateThread, addOne: addThread,
  setCurrentThread, addThreadDeletion,
} = threadsSlice.actions;

export default threadsSlice.reducer;
